import { api } from "#app/http/api";

export const requestResetPasswordToken = async (email: string): Promise<void> => {
  const response = await api.auth.requestResetPassword.mutation({
    body: { email },
  });

  if (response.status === 200) {
    return;
  }
};
